import type { LoginInfo } from '../interface';
import type { IResponse } from '../interface/common';
import { fetch } from '../request';

export interface Shenwan {
  permission: number;
  uid: string;
  token_expired: number;
  valid_ts: number;
}

export interface IOauthUserInfo {
  user_id: number;
  key: string;
  expire_time: string;
  expire_in: number;
  id: number;
  org_name: string;
  username: string;
  phone_number: string;
  email_address: null;
  name: string;
  permission: number;
  custom_org_name: null;
  logo_path: null;
  logo_url: string;
  create_time: string;
  is_expired: boolean;
  expired_time: string;
  is_kicked_user: boolean;
  update_time: string;
  organization_id: number;
  organization_type: number;
  status: number;
  tag_ids: string[];
  remark: string;
  start_time: null;
  end_time: null;
  rights_type: string;
  login_name: string;
  used_credit_coins: string;
  platform_logo_url: string;
  is_edit_logo: boolean;
  is_identify: boolean;
  session_id: string;
}

export interface ILoginLog {
  id: number;
  username: string;
  permission: number;
  login_type: number;
  login_ip: string;
  result: string;
  reason: string;
  create_time: Date;
}

// 校验 token
export const postCheckToken = (service: string) => {
  return fetch<IResponse<any>>('/open_login/oauth/check_token/', {
    method: 'POST',
    body: {
      service,
    },
  });
};

// 请求第三方配置
export const getOAuthAuthorizeConfig = (service: string) => {
  return fetch<IResponse<any>>('/open_login/oauth/authorize_config/', {
    method: 'GET',
    query: {
      service,
    },
  });
};

export const postOAuthLogin = (body: any) => {
  return fetch<IResponse<LoginInfo[]>>('/open_login/oauth/login/', {
    method: 'POST',
    body,
  });
};
